import { render, staticRenderFns } from "./Whisper.vue?vue&type=template&id=8f427420&scoped=true&"
import script from "./Whisper.vue?vue&type=script&lang=js&"
export * from "./Whisper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f427420",
  null
  
)

export default component.exports